<p-toast [baseZIndex]="10000" key="toast-charts"></p-toast>

<div [@fadeIn]="true">
  <div class="offset-md-1 col-10" *ngIf="isIpmConfigured && !hasError && filtersSelected">
    <div class="row">
      <div class="col-md-12 my-4">
        <app-charts-filter
            [filtersSelected]="filtersSelected"
            [isLoading]="isLoading"
            [maxMonthsAllowed]="maxMonthsInGraphics"
            [kpis]="kpis"
            [barCharts]="barCharts"
            [emptyCurrency]="emptyCurrency"
            (stopLoading)="stopLoading($event)"
            (sendFilters)="getChartsData($event)">
        </app-charts-filter>
      </div>
    </div>

    @if (isLoading) {
      <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
    } @else {
      <div class="row mt-4" *ngIf="!isIpmConfigured; else dbError">
        <div class="offset-3 col-6" role="alert">
          <p-message severity="error" text="{{ 'Error Search Graphic' | translate }}"> </p-message>
        </div>
      </div>
      <ng-template #dbError>
        <div class="row mt-4" *ngIf="generalError && generalError.description">
          <div class="mx-auto col-6" role="alert">
            <p-message severity="error" text="{{ generalError.description }}"> </p-message>
          </div>
        </div>
        @if(kpis) {
          <div class="row">
            <div class="col-md-12">
              <app-charts-kpi [kpis]="kpis" [currencyCode]="filtersSelected.currency.code" [userLocale]="userAlocale"> </app-charts-kpi>
            </div>
            <div class="col-md-12">
              <app-charts-list [barCharts]="barCharts" [maxDaysInGraphics]="maxDaysInGraphics" [maxMonthsInGraphics]="maxMonthsInGraphics"
                [currencyCode]="filtersSelected.currency.code" [fromDate]="filtersSelected.fromDate" [toDate]="filtersSelected.toDate"
                [userLocale]="userAlocale">
              </app-charts-list>
            </div>
          </div>
        }
      </ng-template>
    }
  </div>
</div>
